<template>
  <div class="map-actions">
    <img
      src="../../../assets/img-v2/ic_location.png"
      class="icon"
      @click="onLocation"
    />
  </div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  name: "MapActions",
  data() {
    return {};
  },
  methods: {
    ...mapMutations({
      setFitViewToUserPos: "setFitViewToUserPos",
    }),
    onLocation() {
      this.setFitViewToUserPos(true);
      setTimeout(() => {
        this.setFitViewToUserPos(false);
      });
    },
  },
};
</script>

<style scoped lang="scss">
.map-actions {
  display: flex;
  flex-direction: column;

  .icon {
    width: 36px;
    height: 36px;
    display: block;
  }
}
</style>
